import { Pipe, PipeTransform } from '@angular/core';
import { formatDate } from '@angular/common';

@Pipe({name: 'readableDateTime'})
export class ReadableDateTimePipe implements PipeTransform {
    transform(dateTime: string): string {
        let now = new Date();
        let yesterday = new Date();

        yesterday.setDate(yesterday.getDate() - 1);

        if(formatDate(dateTime, 'yyyy-MM-dd', 'se-SE') ==
            formatDate(now, 'yyyy-MM-dd', 'se-SE')) {
            return 'Idag ' + formatDate(dateTime, 'HH:mm', 'se-SE');
        } else if(formatDate(dateTime, 'yyyy-MM-dd', 'se-SE') ==
            formatDate(yesterday, 'yyyy-MM-dd', 'se-SE')) {
            return 'Igår ' + formatDate(dateTime, 'HH:mm', 'se-SE');
        } else {
            return formatDate(dateTime, 'yyyy-MM-dd HH:mm', 'se-SE');
        }
    }
}
